import { useQuery } from "@tanstack/react-query";
import { apiFetch, ApiClientError } from "@/lib/api-client";
import { queryKeys } from "@/lib/query-keys";
import type { PortalFormListItem } from "./types";

// GET /api/portal/forms — list of published forms visible to the partner.
// Backs /portal/forms (sub-bucket 2b page). The handler already applies
// HIDDEN_SLUGS so the SPA doesn't need to filter again.
export function useFormsList() {
  return useQuery<PortalFormListItem[], ApiClientError>({
    queryKey: queryKeys.portal.forms.list(),
    queryFn: () => apiFetch<PortalFormListItem[]>("/portal/forms"),
  });
}
